export default __webpack_public_path__ + "static/media/grupos samsung.2a405a8a.png";